import { initScroller } from "./footerReviewsScroller";

const reviewsSelector = ".footer-top__reviews";

function initReviews() {
  const reviewsElement = document.querySelector<HTMLElement>(reviewsSelector);

  if (!reviewsElement) {
    return;
  }

  initReviewMargin(reviewsElement);
  initScroller(reviewsElement);
}

function initReviewMargin(reviewsElement: HTMLElement) {
  const layoutComputedStyle = getComputedStyle(
    document.querySelector(".layout")!,
  );

  setReviewMargin(reviewsElement, layoutComputedStyle);
  window.addEventListener("resize", () =>
    setReviewMargin(reviewsElement, layoutComputedStyle),
  );
}

function setReviewMargin(
  reviewsElement: HTMLElement,
  layoutComputedStyle: CSSStyleDeclaration,
) {
  reviewsElement.style.paddingLeft = layoutComputedStyle
    .getPropertyValue("--w-spacing")
    .replace(/100%/g, layoutComputedStyle.getPropertyValue("width"));
}

export { initReviews };
